import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-wrapper"
}
const _hoisted_2 = { class: "listings scroll-wrapper" }
const _hoisted_3 = { class: "listings-header" }
const _hoisted_4 = {
  key: 0,
  class: "items-count"
}
const _hoisted_5 = {
  key: 1,
  class: "items-count"
}
const _hoisted_6 = { class: "wrapper-table" }
const _hoisted_7 = { class: "table-scroll" }
const _hoisted_8 = { class: "table-default" }
const _hoisted_9 = { class: "checkbox" }
const _hoisted_10 = { class: "checkbox house" }
const _hoisted_11 = {
  key: 0,
  class: "site-costs"
}
const _hoisted_12 = ["value", "onChange"]
const _hoisted_13 = { class: "facade-checkboxes" }
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = { class: "controls" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.onClose,
    classes: "select-imported-listing-modal height-limited"
  }, {
    content: _withCtx(() => [
      ($props.builders)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, [
              _createElementVNode("div", { class: "modal-title" }, "Select Builders(s)")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                ($setup.getBuildersSelectedCount > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.plural($setup.getBuildersSelectedCount, "Builder")) + " selected", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.plural($props.builders.length, "Builder")), 1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buildersList, (builder, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", _hoisted_9, [
                              _createVNode($setup["CheckboxInput"], {
                                label: builder.name,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                                modelValue: builder.isSelected,
                                "onUpdate:modelValue": ($event: any) => (builder.isSelected = $event),
                                disabled: !builder.houses.length
                              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(builder.houses, (house, idx) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  class: "house",
                                  key: idx
                                }, [
                                  _createElementVNode("td", _hoisted_10, [
                                    _createVNode($setup["CheckboxInput"], {
                                      checkedPartial: true,
                                      label: house.name,
                                      disabled: !builder.isSelected,
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                                      modelValue: house.isSelected && builder.isSelected,
                                      "onUpdate:modelValue": ($event: any) => (house.isSelected = $event)
                                    }, null, 8, ["label", "disabled", "modelValue", "onUpdate:modelValue"]),
                                    (house.isSelected)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                                          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "label" }, "Site costs:", -1)),
                                          _createElementVNode("input", {
                                            class: "input",
                                            value: $setup.getSiteCosts(house),
                                            onChange: (e) => $setup.updatePriceInput(e, house, 'siteCosts'),
                                            type: "text",
                                            placeholder: "$14,000"
                                          }, null, 40, _hoisted_12)
                                        ]))
                                      : _createCommentVNode("", true),
                                    ($props.showFacades && house.isSelected && house.facades && house.facades.length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "facade-selection-label" }, "Select Facades:", -1)),
                                          _createElementVNode("div", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(house.facades, (facade) => {
                                              return (_openBlock(), _createElementBlock("label", {
                                                class: "facade-checkbox-item",
                                                key: facade._id
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  checked: house.selectedFacadeIds && house.selectedFacadeIds.includes(facade._id),
                                                  onChange: ($event: any) => ($setup.toggleFacade(house, facade._id))
                                                }, null, 40, _hoisted_14),
                                                _createElementVNode("span", null, _toDisplayString(facade.name), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: "button default",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onClose()))
              }, "Cancel"),
              _createElementVNode("button", {
                class: "button default primary send",
                disabled: !$setup.canSave,
                onClick: $setup.onSave
              }, "Save", 8, _hoisted_16)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isOpen"]))
}